import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function fetchRequirements(id, data = {}) {
        return axios.get(`${endpoint}/${id}/requirements`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchTasks(id, data = {}) {
        return axios.get(`${endpoint}/${id}/tasks`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchDeadlines(id, data = {}) {
        return axios.get(`${endpoint}/${id}/deadlines`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchRequirements,
        fetchTasks,
        fetchDeadlines
    }
}

export default service
